"use strict";

exports.__esModule = true;
var _ActionButton = require("./ActionButton");
Object.keys(_ActionButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ActionButton[key]) return;
  exports[key] = _ActionButton[key];
});